import { ViewController, JsonFeed, Cache, ChannelSwitchEvent } from "@gaming/srvg-classes-core";
import { OverlayView } from "../../View/OverlayContainerView/OverlayView";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";
import { WIDGET_LIVESETTLEMENTS, WIDGET_STATISTICS_RANKING, WIDGET_STATISTICS_TEAMFORM } from "@gaming/srvg-classes-core";

export class OverlayViewController extends ViewController {
    public name: string;
    overlayView: OverlayView;
    teamAssignmentFeed: JsonFeed;
    teamAssignmentCache: Cache;
    teamResultFeed: JsonFeed;
    teamResultCache: Cache;
    currentMatch: any;
    videoChannel: number;
    mayFillTeamResults: boolean;
    mayFillTeamInfos: boolean;
    isExtendedBetting: boolean;
    phases: any;


    /**
     * constructor
     * set options, create caches for overlay information
     * @param options
     */
    constructor( options ) {
        options = options || {};
        options.view = options.overlayView || null;
        super( options );
        this.name = 'overlayViewController';

        this.overlayView = options.overlayView || null;

        this.teamAssignmentFeed = options.teamAssignmentFeed || null;
        this.teamResultFeed = options.teamResultFeed || null;

        // options for caching
        options.maxSize = options.maxSize || 5;     // max 5 entries
        options.maxAge  = options.maxAge || 30*60;  // 30 min.

        this.teamAssignmentCache = new Cache( options );
        this.teamResultCache = new Cache( options );

        this.videoChannel = options.videoChannel || srvg.videooptions.defaultchannel || 0;

        this.phases = {
            preMatch: srvg.timelinePhases.pre_sportevent.length * 1000 // in ms
        };

        this.mayFillTeamInfos = false;
        this.mayFillTeamResults = false;

        this.isExtendedBetting = srvg.config.extendedBetting;
        if(this.isExtendedBetting && !this.view.$domNode.hasClass('extended-betting')){
            this.view.$domNode.addClass('extended_betting');
        }

    }

    /**
     * handle the phase change event from the timeline
     * set the title with season and matchday in the overlay and fills also the overlay with content
     *
     * @param event - event object from timeline event triggering
     */
    handlePhaseChangeEvent( event:PhaseChangeEvent, provider ) {
        // prepare the title for the view
        this.overlayView.setTitle(
            __('Season') + ' ' + event.season.nr,
            __('Matchday') + ' ' + event.matchday.nr
        );

        // prepare data and show the overlays
        this.setOverlays(event);
    }

    /**
     * handle the switch channel event, for changing the information in the overlays
     *
     * @param event.channel
     */
    handleChannelSwitchEvent(event:ChannelSwitchEvent, provider){
        this.videoChannel = event.newChannel;

        this.setTeamOverlay();
        this.setResultOverlay();
    }




    setOverlays(event){
        var that = this;
        var parameters = this.currentMatch = {
            'matchday': event.matchday.nr,
            'season_id': event.season.id
        };

        that.overlayView.hideAllLayers();

        this.mayFillTeamResults = false;
        this.mayFillTeamInfos = false;
        switch (event.phase.name){
            case 'pre_sportevent':      // pre_match
                if (!this.isExtendedBetting){
                    var overlayNames = [];
                    if( srvg.widgets[WIDGET_STATISTICS_TEAMFORM].enabled ) { overlayNames.push('pre_match_1'); }
                    if( srvg.widgets[WIDGET_STATISTICS_RANKING].enabled ) { overlayNames.push('pre_match_2'); }

                    if( overlayNames.length ) {
                        this.mayFillTeamInfos = true;
                        $.when(
                            // fill overlays with data
                            that.getOverlayTeamData(parameters)
                        ).done(
                            // show the Overlay
                            function() {
                                that.setTeamOverlay(parameters);
                                that.overlayView.showOverlay(
                                    overlayNames,
                                    event.phase.end - app.server.getTime(),
                                    that.phases.preMatch
                                );
                            }
                        );
                    }
                }else{  // if it is extended betting
                    if( srvg.widgets[WIDGET_STATISTICS_TEAMFORM].enabled  && srvg.widgets[WIDGET_STATISTICS_RANKING].enabled){
                        this.mayFillTeamInfos = true;

                        $.when(
                            // fill overlays with data
                            that.getOverlayTeamData(parameters)
                        ).done(
                            // show the Overlay
                            function() {
                                that.setTeamOverlay(parameters);
                                that.overlayView.showOverlay(
                                    'pre_match_extendedBetting',
                                    event.phase.end - app.server.getTime(),
                                    that.phases.preMatch,
                                    function() {},
                                    {
                                        switchMethod: function(channel){
                                            that.setTeamOverlay(null, channel);
                                        },
                                        videoChannel: that.videoChannel}
                                );
                            }
                        );
                    }
                }
                break;
            case 'post_sportevent':     // post_match/match_stats
                if( srvg.widgets[WIDGET_LIVESETTLEMENTS].enabled ) {
                    this.mayFillTeamResults = true;
                    this.mayFillTeamInfos = true;
                    $.when(
                        // fill overlays with data
                        that.getOverlayTeamData(parameters),
                        that.getOverlayTeamResults(parameters)
                    ).done(
                        // show the Overlay
                        function() {
                            that.setTeamOverlay(parameters);
                            that.setResultOverlay(parameters);
                            that.overlayView.showOverlay('post_match', event.phase.end - app.server.getTime());
                        }
                    ).fail(
                        function(){console.error("overlay result request failed");}
                    );
                }
                break;
            case 'post_competition':    // post_season
                //that.view.showLayer('post_season');
                //this.view.showContainer();
                break;
            default:
                that.overlayView.hideContainer();
                break;
        }
    }


    /**
     * fetch the data for the team names and color(from feed or from cache).
     * Deferred resolve if this is sucessful
     *
     * @param parameters - caching parameters to indetify the caching content
     *        (contains season id and matchday as unique key )
     * @return jQuery Deferred Object
     */
    private getOverlayTeamData(parameters){
        var that = this;

        return $.Deferred(function() {
            var result = that.teamAssignmentCache.get(parameters);
            var deferredSelf = this;
            if (!result){
                that.teamAssignmentFeed.poll(
                    parameters,
                    function(data) {
                        that.teamAssignmentCache.set(parameters, data);
                        deferredSelf.resolve();
                    }
                );
            }else{
                deferredSelf.resolve();
            }
        });
    }

    /**
     * Fetch the results for the post match period (from feed or from cache)
     * Deferred resolve if this is sucessful, checks also the validation of th result set.
     *
     * @param parameters - caching parameters to indetify the caching content
     *        (contains season id and matchday as unique key )
     * @return jQuery Deferred Object
     */
    private getOverlayTeamResults(parameters){
        var that = this;
        return $.Deferred(function() {
            var result = that.teamResultCache.get(parameters);
            var deferredSelf = this;
            if (!result){
                that.teamResultFeed.poll(
                    parameters,
                    function(data) {
                        that.teamResultCache.set(parameters, data);
                        if(data.result.length > 0){
                            deferredSelf.resolve();
                        }else{
                            deferredSelf.reject();
                        }
                    }
                );
            }else{
                deferredSelf.resolve();
            }
        });
    }

    /**
     *
     *
     * prepare the team information for the overlays with team information (name and color)
     * @param parameters - caching parameters to indetify the caching content
     *        (contains season id and matchday as unique key )
     * @param [number videoChannel] - optional parameter for videoChannel. Default is the current choosen video channel
     *                                if you want to switch manually pass the videochannel
     */
    private setTeamOverlay(parameters?:any, videoChannel?:number){
        var defaultVideoChannel = 0;

        if(typeof videoChannel === "undefined"){
            videoChannel = this.videoChannel;
        }

        if (this.mayFillTeamInfos){

            var teamInformation = {
                homeTeam: '',
                awayTeam: '',
                homeJerseyColor: '',
                awayJerseyColor: ''
            };

            // fetch data
            if (!parameters){
                parameters = this.currentMatch;
            }
            var teamData    = this.teamAssignmentCache.get(parameters);

            if (!teamData.lineup[videoChannel]){
                videoChannel = defaultVideoChannel;
            }


            var lineup      = teamData.lineup[videoChannel];

            if( lineup ) {
                // change widgets
                var sides = {team1: lineup.away_uid, team2: lineup.home_uid}; // FIXME lineup is empty sometimes
                // switch the position of away and home
                if (srvg.featuresInstances.getSwitchHomeAwayAllocation()){
                    sides = {team1: lineup.home_uid, team2: lineup.away_uid};
                }

                this.refreshWidgetsTeamOverlays({
                    matchId: lineup.match_id,
                    team1uid: sides.team1,
                    team2uid: sides.team2
                });

                // change overlay information

                if( Object.keys(teamData.assignment).length > 0){
                    var jerseyAssignment = {
                        home: teamData.assignment[lineup.home],
                        away: teamData.assignment[lineup.away]
                    };
                    teamInformation = {
                        homeTeam: srvg.translator.getShortTeamName(lineup.home),
                        awayTeam: srvg.translator.getShortTeamName(lineup.away),
                        homeJerseyColor: srvg.customization.teamColors[lineup.home][jerseyAssignment.home],
                        awayJerseyColor: srvg.customization.teamColors[lineup.away][jerseyAssignment.away]
                    };
                }
            }
            this.overlayView.setTeamInformation(teamInformation);
        }
    }


    /**
     *
     * @param parameters - caching parameters to indetify the caching content
     *        (contains season id and matchday as unique key )
     */
    private setResultOverlay(parameters?:any){
        if (this.mayFillTeamResults){
            if (!parameters){
                parameters = this.currentMatch;
            }
            var results =  this.teamResultCache.get(parameters);
            if (results.result[this.videoChannel]){
                this.overlayView.setTeamResults(results.result[this.videoChannel].result);
            }else{
                //this.view.resetTeamResults();
            }
        }
    }


    private refreshWidgetsTeamOverlays(matchTeamInfo, channel?:number){
        srvg.eventExchange.triggerEvent(this.name, {
            eventType: 'addWidget',
            widgetType: 'statisticsteamform',
            element: '#statistics_teamform',
            team1uid: matchTeamInfo.team1uid,
            team2uid: matchTeamInfo.team2uid
        });

        srvg.eventExchange.triggerEvent(this.name, {
            eventType: 'addWidget',
            widgetType: 'statisticsranking',
            element: '#statistics_ranking',
            team1uid: matchTeamInfo.team1uid,
            team2uid: matchTeamInfo.team2uid
        });
        srvg.eventExchange.triggerEvent(this.name, {
            eventType: 'addWidget',
            widgetType: WIDGET_LIVESETTLEMENTS,
            element: '#livesettlements',
            matchId: matchTeamInfo.matchId
        });
        if (srvg.config.extendedBetting) {
            srvg.eventExchange.triggerEvent(this.name, {
                eventType: 'addWidget',
                element: '#statistics_extendedbetting_teamform',
                widgetType: 'statisticsteamform',
                team1uid: matchTeamInfo.team1uid,
                team2uid: matchTeamInfo.team2uid
            });
            srvg.eventExchange.triggerEvent(this.name, {
                eventType: 'addWidget',
                element: '#statistics_extendedbetting_head2head',
                widgetType: 'statisticshead2head',
                team1uid: matchTeamInfo.team1uid,
                team2uid: matchTeamInfo.team2uid
            });
        }
    }


    debugShow(layer?){
        layer = layer || 'pre_sportevent';
        var parameters = {
            matchday: {
                nr: $('#titlebar .sportevent_group_title').html().match('[0-9]+')
            },
            season: {
                nr: $('#titlebar .sportevent_element_title').html().match('[0-9]+'),
                id: 8488
            },
            phase: {
                name: layer || 'pre_sportevent',
                end: (app.server.getTime()+30)
            }
        };
        this.setOverlays(parameters);
    }
}